import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
// Hooks
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import type Dashboard from 'modules/reports/store/models/Dashboard'

interface Props {
  dashboard: Dashboard
  onClose: () => void
  onSuccess: () => void
}

const DeleteModal = ({ onClose, onSuccess, dashboard }: Props) => {
  const { running: deleting, performAction: onDelete } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      const { success } = await asyncAction(() => dashboard.destroy(), {
        successFlash: true,
        errorFlash: false,
      })

      if (success) {
        closePortal({
          preventOnCloseCallbackAfterClose: true,
        })
        onSuccess()
      }
    },
    {
      successFlash: false,
      errorFlash: false,
    }
  )

  return (
    <AuthorizeUser authorizeFn={() => users.current.policy.can('reports.useReports')}>
      <Modal
        illustration="delete"
        title={i18n.t('custom_reports.dashboard.modal.delete.title')}
        description={i18n.t('custom_reports.dashboard.modal.delete.description')}
        onClose={onClose}
        onSubmit={onDelete}
        footer={
          <>
            <Button type="secondary" onClick={onClose}>
              {i18n.t('common.cancel')}
            </Button>
            <Button disabled={deleting} type="negative" submit>
              {i18n.t('common.destroy')}
            </Button>
          </>
        }
      />
    </AuthorizeUser>
  )
}

export default observer(DeleteModal)
